/** @jsx jsx */

import { GatsbyImage } from "gatsby-plugin-image"
import { PropTypes } from "prop-types"
import { jsx, Flex, Heading, Text } from "theme-ui"

import theme from "../gatsby-plugin-theme-ui"
import { Link } from "./Link"

export const AllPages = ({ pages }) => {
  return (
    <div id="read" sx={{ ...theme.basePageStyles.contentContainer }}>
      <Heading as="h1" sx={{ textAlign: "center", mt: 6 }}>
        Start Reading
      </Heading>
      <Flex sx={{ flexWrap: "wrap", justifyContent: "center", my: "50px" }}>
        {pages.map((page) => (
          <Link
            key={page.page_number}
            to={page.slug}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              m: 3,
              textDecoration: "none",
              color: "unset",
              transition: "all 0.2s ease-in",
              "&:hover": {
                filter: "brightness(0.7)",
              },
            }}
          >
            <GatsbyImage image={page.imageData} />
            <Text>{page.page_number}</Text>
          </Link>
        ))}
      </Flex>
    </div>
  )
}
AllPages.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      page_number: PropTypes.number,
      slug: PropTypes.string,
      imageData: PropTypes.object,
    })
  ),
}
